import { object, string } from 'yup'
import { contactReasonsOptionsArray } from 'constants/contactReasons'

export const ContactSupportSchema = object().shape({
  type: string().label('Reason').oneOf(contactReasonsOptionsArray).required(),
  details: string()
    .label('Description')
    .min(20, 'Please enter at least 20 characters for the description')
    .required('Please tell us why you are contacting support.'),
})
